/** Full-screen pause overlay rendered on top of the frozen game world. */
export function PauseOverlay({ onResume, onMenu, onSettings }) {
  return (
    <div className="pause-overlay">
      <h2>PAUSED</h2>

      <div className="pause-controls">
        <p><kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd> / <kbd>↑</kbd><kbd>↓</kbd><kbd>←</kbd><kbd>→</kbd> — Move</p>
        <p><kbd>Q</kbd> / <kbd>Space</kbd> — Melee Attack</p>
        <p><kbd>1</kbd><kbd>2</kbd><kbd>3</kbd><kbd>4</kbd> / <kbd>Z</kbd><kbd>X</kbd><kbd>C</kbd><kbd>V</kbd> — Cast Spell</p>
        <p><kbd>ESC</kbd> — Pause / Resume</p>
      </div>

      <div className="pause-buttons">
        <button onClick={onResume}>▶ Resume</button>
        <button className="btn-secondary" onClick={onSettings}>⚙️ Settings</button>
        <button className="btn-secondary" onClick={onMenu}>Main Menu</button>
      </div>
    </div>
  );
}
